import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import API from "../Context/api";

function ViewDeliveryNote() {
  const { id } = useParams(); // Extract the deliveryNoteID from the URL
  const [deliveryNote, setDeliveryNote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch delivery note data
  useEffect(() => {
    const fetchDeliveryNote = async () => {
      try {
        const response = await API.get(`/deliverynotes/${id}`);
        console.log("Fetched Delivery Note:", response.data);
        setDeliveryNote(response.data);
      } catch (err) {
        setError(err.message || "Failed to fetch delivery note");
      } finally {
        setLoading(false);
      }
    };

    fetchDeliveryNote();
  }, [id]);

  // Handle loading and error states
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error)
    return <p className="text-center p-6 text-red-500">Error: {error}</p>;
  if (!deliveryNote)
    return (
      <p className="text-center p-6 text-gray-500">No delivery note found</p>
    );

  // Destructure delivery note data with fallback values
  const {
    companyName = "",
    companyTIN = "",
    address = "",
    phone = "",
    email = [],
    description = "",
    invoiceDetails: {
      DeliveryNoteNo = "",
      date = "",
      client = "",
      items = [],
      totalAmount = 0,
      vat = 0,
      amountInWords = "",
    } = {},
  } = deliveryNote;

  // Format the date to DD/MM/YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formattedDate = formatDate(date);

  // Function to trigger print
  const handlePrint = () => {
    window.print();
  };

  return (
    // <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-lg font-sans text-sm">
    // <div className="max-w-3xl mx-auto p-6 bg-white text-sm">
    //   {/* Header */}
    //   <div className="text-center mb-4">
    //     <h1 className="text-xl font-bold uppercase">{companyName}</h1>
    //     <p className="text-xs">
    //       Plot M418, Nkrumah Rd P.O. Box 3714K, Kampala, Tel: 0752 2OFONCYTE
    //       901650
    //     </p>
    //     <p className="text-xs">E mail: kevmark2000@gmail.com</p>
    //     <p className="text-xs">Dealers in General Merchandise</p>
    //   </div>

    //   {/* Delivery Note Title and Details */}
    //   <div className="border-2 border-black p-2 mb-2 flex justify-between items-center">
    //     <h2 className="text-lg font-bold uppercase">Delivery Note</h2>
    //     <div className="text-right">
    //       <p>
    //         No: <span className="font-bold">{DeliveryNoteNo}</span>
    //       </p>
    //       <p>
    //         Date: <span className="font-bold">{formattedDate}</span>
    //       </p>
    //     </div>
    //   </div>

    //   {/* Client Info */}
    //   <div className="mb-2">
    //     <p className="text-sm">
    //       M/S <span className="underline">{client}</span>
    //     </p>
    //   </div>

    //   {/* Delivery Instruction */}
    //   <div className="border-2 border-black p-2 mb-2">
    //     <p className="text-sm font-bold uppercase">
    //       Please receive the following goods
    //     </p>
    //   </div>

    //   {/* Client Info (Repeated) and Date */}
    //   <div className="flex justify-between mb-2">
    //     <p className="text-sm">
    //       DELIV. M/S <span className="underline">{client}</span>
    //     </p>
    //     <p className="text-sm">{formattedDate}</p>
    //   </div>

    //   {/* Items Table */}
    //   {/* Items Table */}
    //   <table className="w-full border border-collapse mb-4">
    //     <thead>
    //       <tr className="border">
    //         <th className="border p-1 text-left">Unit</th>
    //         <th className="border p-1 text-left">Qty</th>
    //         <th className="border p-1 text-left">Particulars / Description</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {items.map((item, index) => (
    //         <tr key={index} className="border">
    //           <td className="border p-1">{index + 1}</td>
    //           <td className="border p-1">{item.quantity}</td>
    //           <td className="border p-1">{item.particulars}</td>
    //         </tr>
    //       ))}
    //     </tbody>
    //   </table>

    //   {/* Footer Section */}
    //   <div className="mb-4">
    //     <p className="text-xs">Your order No: {DeliveryNoteNo}</p>
    //     <p className="text-xs mt-2">
    //       Receive the above goods in good order and condition. Negotiable before
    //       signature:
    //     </p>
    //     <div className="flex justify-between mt-4">
    //       <div>
    //         <p className="text-xs">
    //           Delivered by:{" "}
    //           <span className="inline-block w-40 border-b border-black"></span>
    //         </p>
    //       </div>
    //       <div>
    //         <p className="text-xs">
    //           Received by:{" "}
    //           <span className="inline-block w-40 border-b border-black"></span>
    //         </p>
    //       </div>
    //     </div>
    //   </div>

    //   {/* Print Button */}
    //   <button
    //     onClick={handlePrint}
    //     className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors print:hidden"
    //   >
    //     Print
    //   </button>
    // </div>
    <div className="max-w-3xl mx-auto p-4 sm:p-6 bg-white border border-gray-300 rounded-lg shadow-sm my-8 text-xs sm:text-sm">
      {/* Header */}
      <div className="text-center mb-6 border border-gray-200 rounded-md p-3 sm:p-4">
        <h1 className="text-xl sm:text-2xl font-extrabold text-gray-900 uppercase tracking-tight">
          <img
            src="/images/logo.png"
            alt="Company Logo"
            className="h-20 w-20 mr-2 inline-block"
          />
          {companyName}
        </h1>
        <p className="text-xs sm:text-sm text-gray-600 mt-2 leading-relaxed">
          Plot M418, Nkrumah Rd P.O. Box 3714K, Kampala, Tel: 0752 2OFONCYTE
          901650
        </p>
        <p className="text-xs sm:text-sm text-gray-600">
          Email: kevmark2000@gmail.com
        </p>
        <p className="text-xs sm:text-sm text-gray-600 italic">
          Dealers in General Merchandise
        </p>
      </div>

      {/* Delivery Note Title and Details */}
      <div className="border border-gray-200 rounded-md p-3 sm:p-4 mb-4 flex justify-between items-center">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-800 uppercase tracking-wide">
          Delivery Note
        </h2>
        <div className="text-right">
          <p className="text-xs sm:text-sm text-gray-700">
            No:{" "}
            <span className="font-bold text-gray-900">{DeliveryNoteNo}</span>
          </p>
          <p className="text-xs sm:text-sm text-gray-700">
            Date:{" "}
            <span className="font-bold text-gray-900">{formattedDate}</span>
          </p>
        </div>
      </div>

      {/* Client Info */}
      <div className="mb-4 bg-gray-50 p-3 sm:p-4 rounded-md border border-gray-200">
        <p className="text-xs sm:text-sm text-gray-700">
          M/S <span className="underline font-semibold">{client}</span>
        </p>
      </div>

      {/* Delivery Instruction */}
      <div className="border border-gray-200 rounded-md p-3 sm:p-4 mb-4 bg-gray-50">
        <p className="text-xs sm:text-sm font-semibold text-gray-800 uppercase">
          Please receive the following goods
        </p>
      </div>

      {/* Client Info (Repeated) and Date */}
      <div className="flex justify-between mb-4 border-b border-gray-200 pb-3">
        <p className="text-xs sm:text-sm text-gray-700">
          DELIV. M/S <span className="underline font-semibold">{client}</span>
        </p>
        <p className="text-xs sm:text-sm text-gray-700">{formattedDate}</p>
      </div>

      {/* Items Table */}
      <div className="mb-6 border border-gray-200 rounded-md overflow-x-auto">
        <table className="w-full border-collapse bg-white">
          <thead>
            <tr className="bg-gray-100 text-gray-700 uppercase tracking-wider">
              <th className="border-b border-gray-200 p-2 sm:p-3 text-left font-medium w-[10%]">
                Unit
              </th>
              <th className="border-b border-gray-200 p-2 sm:p-3 text-left font-medium w-[15%]">
                Qty
              </th>
              <th className="border-b border-gray-200 p-2 sm:p-3 text-left font-medium w-[75%]">
                Particulars / Description
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={index}
                className="border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150"
              >
                <td className="border-r border-gray-200 p-2 sm:p-3 text-gray-700">
                  {index + 1}
                </td>
                <td className="border-r border-gray-200 p-2 sm:p-3 text-gray-700">
                  {item.quantity}
                </td>
                <td className="p-2 sm:p-3 text-gray-700">{item.particulars}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer Section */}
      <div className="mb-6 p-3 sm:p-4 bg-gray-50 rounded-md border border-gray-200">
        <p className="text-xs sm:text-sm text-gray-700">
          Your order No: {DeliveryNoteNo}
        </p>
        <p className="text-xs sm:text-sm text-gray-700 mt-2">
          Receive the above goods in good order and condition. Negotiable before
          signature:
        </p>
        <div className="flex flex-col sm:flex-row justify-between mt-4 gap-4">
          <div>
            <p className="text-xs sm:text-sm text-gray-700">
              Delivered by:{" "}
              <span className="inline-block w-32 sm:w-40 border-b border-gray-300"></span>
            </p>
          </div>
          <div>
            <p className="text-xs sm:text-sm text-gray-700">
              Received by:{" "}
              <span className="inline-block w-32 sm:w-40 border-b border-gray-300"></span>
            </p>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <button
        onClick={handlePrint}
        className="w-full sm:w-auto bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200 print:hidden text-xs sm:text-sm"
      >
        Print
      </button>
    </div>
  );
}

export default ViewDeliveryNote;
